<template>
  <div>
    <Pos_product_empty/>
  </div>
</template>

<script>
import Pos_product_empty from "@/components/adminArin/pos_system/product/Pos_product_empty";
export default {
  name: "PosProductEmpty",
  components: {
    Pos_product_empty
  }
}
</script>

<style scoped>

</style>
